import React from "react";
// import {storage} from '../../../../_firebase'
// const maleImage = () => {
//   storage.child('placeholder/male.png').getDownloadURL().then(url=>{
//     return url;
//   })
// }
// const female = storage.child('placeholder/female.png')
const GenderSelect = ({ male, onChange, disable }) => {
  return (
    <div className="row">
      <div className="col-xs-6">
        <div
          className={male ? "profile gender selected" : "profile gender"}
          style={{ marginBottom: "1em", cursor: "pointer" }}
          onClick={() => {
            if (!disable) {
              onChange(false);
            }
          }}
        >
          <div className="profile-image tip" title="Select Male">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/fir-amst-8de23.appspot.com/o/placeholder%2Fmale.png?alt=media&token=f37028c3-cb83-4b39-88a7-9eb3d394bd1c"
              alt="male"
            />
          </div>
        </div>
      </div>
      <div className="col-xs-6">
        <div
          className={male ? "profile gender" : "profile selected gender"}
          style={{ marginBottom: "1em", cursor: "pointer" }}
          onClick={() => {
            if (!disable) {
              onChange(true);
            }
          }}
        >
          <div className="profile-image tip" title="Select Female">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/fir-amst-8de23.appspot.com/o/placeholder%2Ffemale.png?alt=media&token=9526c2bb-d143-4749-bc41-1bce7fc1f8c1"
              alt="female"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenderSelect;



// WEBPACK FOOTER //
// ./src/_components/UI/AccountCreatedModal/GenderSelect/index.js